/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Infragraph Service
 * APIs for managing Infragraph.
 *
 * The version of the OpenAPI document: 2025-05-07
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * SnapshotStatus defines the possible states of a snapshot. A snapshot can only
 * be in one of these states at any given time.
 *
 *  - SNAPSHOT_STATUS_STARTED: The snapshot was started.
 *  - SNAPSHOT_STATUS_ABANDONED: The snapshot was abandoned, meaning it was not completed successfully.
 *  - SNAPSHOT_STATUS_PARTIAL: The snapshot finished with recoverable errors.
 *  - SNAPSHOT_STATUS_FAILED: The snapshot failed with an unrecoverable error.
 *  - SNAPSHOT_STATUS_FINISHED: The snapshot has been successfully completed.
 * @export
 * @enum {string}
 */
export var HashicorpCloudInfragraph20250507SnapshotStatus;
(function (HashicorpCloudInfragraph20250507SnapshotStatus) {
    HashicorpCloudInfragraph20250507SnapshotStatus["UNSPECIFIED"] = "SNAPSHOT_STATUS_UNSPECIFIED";
    HashicorpCloudInfragraph20250507SnapshotStatus["STARTED"] = "SNAPSHOT_STATUS_STARTED";
    HashicorpCloudInfragraph20250507SnapshotStatus["ABANDONED"] = "SNAPSHOT_STATUS_ABANDONED";
    HashicorpCloudInfragraph20250507SnapshotStatus["PARTIAL"] = "SNAPSHOT_STATUS_PARTIAL";
    HashicorpCloudInfragraph20250507SnapshotStatus["FAILED"] = "SNAPSHOT_STATUS_FAILED";
    HashicorpCloudInfragraph20250507SnapshotStatus["FINISHED"] = "SNAPSHOT_STATUS_FINISHED";
})(HashicorpCloudInfragraph20250507SnapshotStatus || (HashicorpCloudInfragraph20250507SnapshotStatus = {}));
export function HashicorpCloudInfragraph20250507SnapshotStatusFromJSON(json) {
    return HashicorpCloudInfragraph20250507SnapshotStatusFromJSONTyped(json, false);
}
export function HashicorpCloudInfragraph20250507SnapshotStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HashicorpCloudInfragraph20250507SnapshotStatusToJSON(value) {
    return value;
}
